/* =========================================================================
   LANÇAMENTO — DUAS CAIXAS (a peça sozinha ou o conjunto)

   A cliente escolhe a caixa; a caixa aberta pede o TAMANHO de cada peça que
   ela contém. O botão adiciona tudo ao carrinho de uma vez.

   ORDEM DAS DECISÕES, que é o motivo de a caixa vir antes do tamanho:
   escolher tamanho de duas peças para só então descobrir o preço do conjunto
   inverteria a pergunta que a página faz. Primeiro "uma ou duas?", depois "qual
   número?".

   O PREÇO É SEMPRE SOMADO DAS VARIANTES, nunca um número de configuração.
   Enquanto ela não escolhe tamanho, soma a primeira variante disponível de cada
   peça — nos dois produtos deste lançamento o preço não varia por tamanho, mas
   se um dia variar, o que a página mostra continua sendo o que o carrinho cobra.
   ========================================================================= */

(function () {
  if (window.__tpLancamento) return;
  window.__tpLancamento = true;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function attr(s) { return esc(s); }

  /* Duas casas sempre ("07s", nao "7s"), igual ao tp-relogio faz no Liquid. Sem
     isto a pilula mudaria de largura quando o numero passa de 10 para 9 e a
     etiqueta ficaria pulando na borda da caixa. */
  function dd(n) {
    n = Number(n) || 0;
    return n < 10 ? '0' + n : String(n);
  }

  /* NOME DA PECA, DESAMBIGUADO QUANDO A CAIXA REPETE O MESMO PRODUTO.

     O nome existe para dizer de QUAL peca sao a cor e o tamanho logo abaixo -
     numa caixa de conjunto sao dois blocos iguais empilhados. Isso resolvia
     enquanto as duas pecas eram diferentes ("LipLegging" e "Top Basic").

     No teste A/B de duas LipLeggings as duas passaram a ter o MESMO titulo, e a
     desambiguacao morreu junto: dois blocos "LipLegging" identicos, e o botao
     dizendo "Escolha o tamanho: LipLegging" sem dizer qual. A cliente nao tem
     como saber o que falta.

     Com titulo repetido, entra a ordem ("1a LipLegging", "2a LipLegging" com
     ordinal). Com
     titulos diferentes nada muda - o caminho antigo continua igual. */
  function nomeDaPeca(caixa, iProd) {
    var prods = (caixa && caixa.produtos) || [];
    var p = prods[iProd] || {};
    var titulo = p.title || '';
    var repetido = false;
    for (var i = 0; i < prods.length; i++) {
      if (i !== iProd && prods[i] && prods[i].title === titulo) { repetido = true; break; }
    }
    if (!repetido) return titulo;
    return (iProd + 1) + 'ª ' + titulo;
  }

  /* A foto da peça vem em 1000px, largura da galeria. Nas miniaturas ela ocupa
     72px ou menos: pedir o arquivo inteiro é baixar ~15x mais imagem do que a
     tela usa, várias vezes na mesma caixa — e foi o que deixou a fileira em
     branco enquanto tudo carregava. O CDN do Shopify entrega o tamanho pedido
     na própria URL. */
  function miniatura(url) {
    return String(url || '').replace(/([?&]width=)\d+/, '$1200');
  }

  /* ESTILO DA BOLINHA DE COR, num lugar só.

     Usado pelo seletor de cor e pela frase do presente, que precisa mostrar
     exatamente a mesma bolinha da cor do lançamento para a cliente ligar as
     duas coisas. Escrito duas vezes, bastaria alguém cadastrar swatch de cor
     num produto para a frase e o seletor mostrarem coisas diferentes.

     `bg` vem do swatch do produto e pode ser cor OU imagem. Escrever os dois
     como `background:` zeraria o `background-size: cover` do CSS — o shorthand
     reseta o que não vem nele, e a foto apareceria em tamanho natural. */
  function estiloSwatch(cc) {
    if (!cc) return '';
    if (cc.bg && cc.bg.indexOf('url(') === 0) return 'background-image:' + cc.bg;
    if (cc.bg) return 'background-color:' + cc.bg;
    if (cc.img) return 'background-image:url(' + miniatura(cc.img) + ')';
    return '';
  }

  function dinheiro(centavos) {
    return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
  }

  /* Um lugar so para a conta do desconto: o preco da caixa, o parcelado e
     qualquer coisa que venha depois precisam do MESMO numero.

     A CONTA E POR LINHA, NAO SOBRE O TOTAL, e a diferenca e de um centavo que
     apareceria no checkout. A Shopify trunca os centavos de CADA item, nao do
     pedido. Conferido com draftOrderCalculate: LipLegging 359,90 + Top Basic
     169,90 volta 450,34 (30592 + 14442, cada um truncado). Sobre o total daria
     450,33 - e a caixa estaria prometendo um centavo a menos do que o carrinho
     cobra. Eu fiz exatamente esse erro na primeira versao.

     O MINIMO, ao contrario, e do PEDIDO: quem decide se o desconto existe e a
     soma da caixa, nao o preco de cada peca. Por isso ele e testado fora do
     laco - senao o Top Basic de 169,90 dentro de um conjunto de 619,80 ficaria
     de fora. */
  function aplicaDesconto(linhas, d) {
    var total = 0;
    var i;
    for (i = 0; i < linhas.length; i++) total += linhas[i];
    if (!d || !(d.pct > 0) || total < d.minimo) return total;
    var soma = 0;
    for (i = 0; i < linhas.length; i++) {
      soma += linhas[i] - Math.floor((linhas[i] * d.pct) / 100);
    }
    return soma;
  }

  /* ACENTO NÃO PODE CUSTAR A COR ESCOLHIDA.

     A mesma cor é "Café" numa versão da peça e "Cafe" na outra. Comparando cru,
     a cliente escolhe Café, troca para com bolso e cai na cor padrão. Normalizo
     dos dois lados: sem acento, minúscula, sem espaço nas pontas. */
  function semAcento(s) {
    return String(s == null ? '' : s)
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .trim().toLowerCase();
  }
  /* Sistema pedindo menos movimento: troca seca, sem fade nem rolagem animada.
     Quem liga isso costuma ligar por enjoo ou vertigem, não por gosto. */
  function semMovimento() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function equivalente(nomes, alvo) {
    if (!alvo) return null;
    var a = semAcento(alvo);
    for (var i = 0; i < nomes.length; i++) {
      if (semAcento(nomes[i]) === a) return nomes[i];
    }
    return null;
  }

  /* SCRIPT COLADO POR innerHTML NÃO RODA.

     É regra do HTML, não bug do navegador: `<script>` que chega por innerHTML
     entra no DOM inerte, de propósito. E as tabelas de medidas moram em
     metacampo, com o script de troca de aba e de cor embutido no próprio HTML —
     é assim que a tabela da LipLegging troca a tabela ao clicar no swatch.

     Resultado: dentro do pop-up da caixa, os swatches apareciam e não faziam
     nada, enquanto na página da LipLegging funcionavam. Recriar cada <script>
     como um nó novo é o que o navegador aceita como "isto é para executar".

     Vale para qualquer guia, não só o da LipLegging: metacampo com script
     passa a funcionar aqui sem eu vir mexer de novo. */
  function ligarScripts(raiz) {
    if (!raiz) return;
    var velhos = raiz.querySelectorAll('script');
    for (var i = 0; i < velhos.length; i++) {
      var velho = velhos[i];
      var novo = document.createElement('script');
      for (var a = 0; a < velho.attributes.length; a++) {
        novo.setAttribute(velho.attributes[a].name, velho.attributes[a].value);
      }
      novo.textContent = velho.textContent;
      velho.parentNode.replaceChild(novo, velho);
    }
  }

  /* O laço de presente, num lugar só. Ele aparece no canto da caixa (contando
     quantos são) e no canto de cada miniatura (dizendo qual é qual) — duas
     cópias do mesmo desenho seria uma para esquecer de corrigir. */
  function iconePresente(classe) {
    return '<svg class="' + classe + '" viewBox="0 0 20 20" fill="none" stroke="currentColor" ' +
      'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M2.9 9.4h14.2v7.2a1 1 0 0 1-1 1H3.9a1 1 0 0 1-1-1V9.4z"/>' +
      '<path d="M2.1 6.6h15.8v2.8H2.1z"/><path d="M10 6.6v11"/>' +
      '<path d="M10 6.6S8.9 2.5 6.8 2.5a1.9 1.9 0 0 0 0 4.1H10z"/>' +
      '<path d="M10 6.6s1.1-4.1 3.2-4.1a1.9 1.9 0 0 1 0 4.1H10z"/></svg>';
  }

  function Controlador(raiz, cfg) {
    this.raiz = raiz;
    this.cfg = cfg;
    this.caixas = cfg.caixas || [];
    this.atual = 0;
    // Escolha de tamanho por caixa e por peça: sel[iCaixa][iProduto] = 'M'
    this.sel = this.caixas.map(function (c) {
      return (c.produtos || []).map(function () { return null; });
    });

    /* A COR É POR CAIXA, como o tamanho.

       As duas caixas são compras alternativas, não a mesma compra vista duas
       vezes: quem está comparando "só a legging em Cereja" com "o conjunto em
       Bosque" precisa que uma escolha não mexa na outra. Foi assim que nasceu e
       assim ficou depois de testar o contrário. */
    var self = this;
    this.cor = this.caixas.map(function (c) {
      return (c.produtos || []).map(function (p) { return self.corPadrao(p); });
    });
    this.elCaixas = raiz.querySelector('[data-tp-lc-caixas]');
    this.elCta = raiz.querySelector('[data-tp-lc-cta]');
    this.elCtaLabel = raiz.querySelector('[data-tp-lc-cta-label]');
    /* PARCELAMENTO: a regra vem toda do Liquid, que a lê da mesma cadeia do
       botão de compra do resto da loja (metacampo do produto -> metacampo da
       loja -> configuração do tema). Aqui só se aplica.

       `override` manda o número direto. Sem ele, vale a configuração do tema, e
       aí entra o MÍNIMO POR PARCELA: o parcelamento anunciado é o maior cuja
       parcela não fique abaixo do mínimo da loja. É por isso que não dá para
       simplesmente dividir por 6 — em produto barato o resto do site mostraria
       3x e esta página mostraria 6x de um valor que a loja não aceita. */
    this.elParcelas = raiz.querySelector('[data-tp-lc-parcelas] .tp-installments');
    this.parcOverride = parseInt(raiz.dataset.parcelas || '0', 10) || 0;
    this.parcTema = parseInt(raiz.dataset.parcelasTema || '6', 10) || 6;
    this.parcMinima = parseInt(raiz.dataset.parcelaMinima || '0', 10) || 0;
    this.parcLigado = raiz.dataset.parcelamento !== 'false';
    this.prepararGaleria();
    this.montar();
    /* Abre ja na peca da caixa escolhida: sem isto a galeria so obedeceria
       depois do primeiro clique, e a cliente veria a peca certa com as cores
       todas misturadas. */
    this.mostrarNaGaleria(this.atual, 0, false);
  }

  /* Índice da opção de TAMANHO. É a primeira opção que não é a de cor — mesma
     regra do seletor de kit, para as duas telas concordarem sobre o que é
     tamanho num produto qualquer. */
  Controlador.prototype.indiceTamanho = function (p) {
    var ci = typeof p.colorIndex === 'number' ? p.colorIndex : -1;
    var n = (p.optionNames || []).length;
    for (var i = 0; i < n; i++) if (i !== ci) return i;
    return -1;
  };

  /* Cores que a peça realmente tem VARIANTE, na ordem do produto.

     Sai de `colors` (que traz o swatch) mas confere contra as variantes: cor
     declarada sem variante viraria um botão que não leva a lugar nenhum. */
  Controlador.prototype.cores = function (p) {
    var ci = typeof p.colorIndex === 'number' ? p.colorIndex : -1;
    if (ci < 0) return [];
    var vs = p.variants || [];
    var temVariante = function (nome) {
      for (var i = 0; i < vs.length; i++) if (vs[i].options[ci] === nome) return true;
      return false;
    };
    var lista = (p.colors || []).filter(function (c) { return temVariante(c.name); });
    if (lista.length) return lista;
    // Produto sem `colors` preenchido: monta a partir das próprias variantes.
    var vistos = [];
    vs.forEach(function (v) {
      var n = v.options[ci];
      if (n != null && vistos.indexOf(n) === -1) vistos.push(n);
    });
    return vistos.map(function (n) { return { name: n, bg: '', img: '' }; });
  };

  /* COR COM QUE A PEÇA ABRE — e por que NÃO é a do lançamento.
     
     Eram a mesma coisa, e por isso a página abria na Bosque. Só que a Bosque é
     edição limitada e custa mais: abrir nela é a primeira coisa que a cliente vê
     ser um preço mais alto do que o anunciado na vitrine. A página passa a abrir
     na cor de catálogo e a Bosque se vende no clique, já com o preço à vista.
     
     Perder a Bosque da abertura não a esconde: a bolinha dela continua marcada
     como limitada (`is-limitada`), que é o que faz a cliente clicar.
     
     `corInicial` não substitui `cor` — são dois papéis distintos que estavam
     empilhados num campo só. `cor` continua sendo a do LANÇAMENTO, e é dela que
     dependem o selo, o presente e os textos que a nomeiam. Sem `corInicial`
     configurada, cai em `cor` e o comportamento é o antigo. */
  Controlador.prototype.corPadrao = function (p) {
    var alvo = (this.cfg.corInicial || this.cfg.cor || '').trim();
    var cs = this.cores(p);
    if (!cs.length) return null;
    for (var i = 0; i < cs.length; i++) if (cs[i].name === alvo) return alvo;
    return cs[0].name;
  };

  Controlador.prototype.corDe = function (iCaixa, iProd) {
    return (this.cor[iCaixa] || [])[iProd] || null;
  };

  /* Variantes da peça na cor dada. A cor vem por PARÂMETRO, não do estado: ela
     é por caixa, e a mesma peça responde diferente em cada uma. Sem cor (peça de
     cor única, ou produto sem opção de cor), todas. */
  Controlador.prototype.variantes = function (p, cor) {
    var ci = typeof p.colorIndex === 'number' ? p.colorIndex : -1;
    var vs = p.variants || [];
    if (!cor || ci < 0) return vs;
    return vs.filter(function (v) { return v.options[ci] === cor; });
  };

  Controlador.prototype.tamanhos = function (p, cor) {
    var si = this.indiceTamanho(p);
    if (si < 0) return [];
    var vistos = [];
    this.variantes(p, cor).forEach(function (v) {
      var t = v.options[si];
      if (t != null && vistos.indexOf(t) === -1) vistos.push(t);
    });
    return vistos;
  };

  Controlador.prototype.variantePorTamanho = function (p, tamanho, cor) {
    var si = this.indiceTamanho(p);
    var vs = this.variantes(p, cor);
    if (si < 0) return vs[0] || null;
    for (var i = 0; i < vs.length; i++) if (vs[i].options[si] === tamanho) return vs[i];
    return null;
  };

  // Variante que representa a peça enquanto ninguém escolheu tamanho.
  Controlador.prototype.varianteMostrada = function (iCaixa, iProd) {
    var p = this.caixas[iCaixa].produtos[iProd];
    var cor = this.corDe(iCaixa, iProd);
    var t = this.sel[iCaixa][iProd];
    if (t) return this.variantePorTamanho(p, t, cor);
    var vs = this.variantes(p, cor);
    for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
    return vs[0] || null;
  };

  /* Alguma peça saiu da cor do lançamento?
     É a pergunta que decide o que a caixa ainda pode prometer. */
  Controlador.prototype.foraDaCor = function (iCaixa) {
    var self = this;
    var alvo = (this.cfg.cor || '').trim();
    if (!alvo) return false;
    return (this.caixas[iCaixa].produtos || []).some(function (p, iProd) {
      var cs = self.cores(p);
      return cs.length > 1 && self.corDe(iCaixa, iProd) !== alvo;
    });
  };

  /* O QUE NOMEIA A COR DO LANÇAMENTO SAI JUNTO COM ELA.

     A faixa é "Faixa de Cabelo - Bosque" e a linha diz "Faixa de cabelo Bosque
     de presente". Nas duas, o texto promete um item daquela cor — em Cereja a
     promessa deixa de existir, e mantê-la na tela seria anunciar um presente
     que o carrinho não vai dar (a regra do presente também casa por cor).

     Uma regra só, aplicada a presente e a linha de item, em vez de duas listas
     de exceção para manter em dia. */
  Controlador.prototype.mencionaACor = function (texto) {
    var alvo = (this.cfg.cor || '').trim().toLowerCase();
    if (!alvo) return false;
    return String(texto || '').toLowerCase().indexOf(alvo) !== -1;
  };

  /* O título da caixa é escrito com a cor do lançamento ("Só a LipLegging
     Bosque"). Fora dela, a palavra sai: com Cereja selecionada, o título estaria
     nomeando uma cor que a caixa não vende mais. Mesma regra dos presentes e das
     linhas de item — o que nomeia a cor sai com ela. */
  Controlador.prototype.tituloDaCaixa = function (iCaixa) {
    var t = this.caixas[iCaixa].titulo || '';
    var alvo = (this.cfg.cor || '').trim();
    if (!alvo || !this.foraDaCor(iCaixa) || !this.mencionaACor(t)) return t;
    var re = new RegExp('\\s*' + alvo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*', 'gi');
    return t.replace(re, ' ').replace(/\s+/g, ' ').trim();
  };

  /* O PRESENTE POR VALOR TEM MÍNIMO, E O MÍNIMO É POR CAIXA.

     Mesma família do frete e do "15% OFF" logo abaixo, e pelo mesmo motivo: a
     lista da caixa diz o que a cliente LEVA ali, não o que existe na loja. A
     LipLegging sozinha é R$ 359,90 e o Top Basic R$ 169,90 — as duas abaixo dos
     R$ 449 — e a caixa solo prometia uma necessaire que o carrinho não daria.

     E é por caixa, não por página: na mesma tela a caixa do conjunto (R$ 529)
     alcança e a solo não. Uma resposta só para a página estaria errada numa das
     duas metades, sempre.

     `minimo <= 0` significa SEM MÍNIMO e a promessa vale sempre — mesma leitura
     do frete, e o oposto de fazer a linha desaparecer quando alguém zera o
     campo (defeito que já aconteceu ali). */
  Controlador.prototype.alcancaPresente = function (iCaixa) {
    if (!this.cfg.presenteAtivo) return false;
    var minimo = this.cfg.presenteMinimo;
    if (typeof minimo !== 'number' || minimo <= 0) return true;
    return this.totalCaixa(iCaixa) >= minimo;
  };

  Controlador.prototype.presentesDaCaixa = function (iCaixa) {
    var self = this;
    var gs = this.caixas[iCaixa].presentes || [];

    /* PRESENTE DA ROLETA (24/09/2026): vem marcado `roleta: true` e so existe
       para quem ja girou -- a marca e o handle gravado pela roleta. Sem ele, a
       vitrine nao promete um presente que o carrinho nao vai dar. */
    var ganhouRoleta = null;
    try { ganhouRoleta = localStorage.getItem('tp-roleta-presente'); } catch (e) {}
    if (!ganhouRoleta) gs = gs.filter(function (g) { return !g.roleta; });

    /* Filtra pelo HANDLE, não pelo título: "Necessaire Blumi" é texto editável,
       e a faixa de cabelo que vive na mesma lista tem regra de COR, não de
       valor — confundir as duas tiraria o presente errado. */
    if (!this.alcancaPresente(iCaixa)) {
      var alvo = this.cfg.presenteHandle;
      gs = gs.filter(function (g) { return !alvo || g.handle !== alvo; });
    }

    if (!this.foraDaCor(iCaixa)) return gs;
    return gs.filter(function (g) { return !self.mencionaACor(g.titulo); });
  };

  /* A BOLINHA DA COR DO LANÇAMENTO, para a frase do presente.

     Procura a cor alvo entre as peças da caixa e devolve o estilo da bolinha
     dela — a MESMA que aparece no seletor logo abaixo. É esse espelhamento que
     faz a cliente entender "esta cor aqui é aquela cor lá" sem precisar ler.

     Devolve vazio se a cor não existir na caixa; aí a frase sai sem bolinha em
     vez de sair com um círculo branco solto. */
  Controlador.prototype.corAlvoSwatch = function (iCaixa) {
    var alvo = (this.cfg.cor || '').trim();
    if (!alvo) return '';
    var self = this;
    var estilo = '';
    (this.caixas[iCaixa].produtos || []).forEach(function (p) {
      if (estilo) return;
      self.cores(p).forEach(function (cc) {
        if (!estilo && cc.name === alvo) estilo = estiloSwatch(cc);
      });
    });
    return estilo;
  };

  /* O MELHOR CUPOM QUE ESTE TOTAL ALCANCA -- um so, nunca dois.

     A caixa de duas pecas alcanca os dois cupons (R$ 719,80 passa dos R$ 599 do
     VIP25 e o VIP20 nao tem minimo). Listar os dois faria a cliente ler como
     soma, e eles nao somam: os dois sao classe ORDER na Shopify, e so um
     desconto de pedido se aplica. Entao vence o de maior percentual, e e ele
     que aparece na linha de beneficio E na tag de preco -- a mesma escolha nos
     dois lugares, por construcao. */
  Controlador.prototype.melhorCupom = function (total) {
    var melhor = null;
    (this.cfg.cupons || []).forEach(function (c) {
      if (!c || !(c.pct > 0)) return;
      if (total < (c.minimo || 0)) return;
      if (!melhor || c.pct > melhor.pct) melhor = c;
    });
    return melhor;
  };

  /* O PRECO QUE A CLIENTE VAI PAGAR NESTA CAIXA: desconto de campanha e, por
     cima dele, o melhor cupom aplicavel.

     Existe porque o numero era recalculado em quatro lugares (preco da caixa,
     parcelado da caixa, parcelado embaixo do botao, teto de parcelas na lista de
     beneficios) e tres deles paravam no desconto de campanha. Resultado na tela:
     "R$ 287,92" no preco e "9x de R$ 39,98" logo abaixo -- a parcela do valor
     cheio, R$ 359,90/9. Com um lugar so, nao ha de onde divergir.

     Os cupons sao ORDER-class: aplicam sobre o subtotal ja descontado, entao a
     ordem aqui (desconto, depois cupom) e a mesma do checkout. */
  Controlador.prototype.precoFinalCaixa = function (iCaixa) {
    var base = aplicaDesconto(this.linhasCaixa(iCaixa), this.cfg.desconto);
    var cup = this.melhorCupom(base);
    if (!cup) return base;
    return Math.floor((base * (100 - cup.pct) + 50) / 100);
  };

  Controlador.prototype.itensDaCaixa = function (iCaixa) {
    var self = this;
    var linhas = String(this.caixas[iCaixa].itens || '')
      .split('\n').map(function (l) { return l.trim(); }).filter(Boolean);

    if (this.foraDaCor(iCaixa)) {
      linhas = linhas.filter(function (l) { return !self.mencionaACor(l); });
    }

    /* O FRETE É CALCULADO, NÃO ESCRITO.

       Como linha fixa ele aparecia em caixa que não alcança o mínimo — o top
       sozinho custa R$ 189,90 e a legging sozinha R$ 379,90, os dois abaixo dos
       R$ 399. A caixa prometia um frete que o carrinho ia cobrar.

       Calculado, ele também acompanha a troca de cor: se um dia uma cor mais
       barata derrubar o conjunto abaixo da linha, a promessa sai sozinha. */
    var total = this.totalCaixa(iCaixa);
    var minimo = this.cfg.freteGratis;
    var rotulo = (this.cfg.freteRotulo || 'Frete grátis').trim();
    var jaTem = linhas.some(function (l) { return l.toLowerCase().indexOf('frete') !== -1; });
    /* `minimo` em 0 (ou negativo) significa SEM MÍNIMO: o frete é grátis em
       qualquer pedido, e a linha entra sempre. Antes a condição era
       `minimo > 0 && total >= minimo`, então zerar o mínimo fazia a promessa
       DESAPARECER — o oposto do que zerar quer dizer. */
    var semMinimo = typeof minimo !== 'number' || minimo <= 0;
    if (!jaTem && rotulo && (semMinimo || total >= minimo)) {
      linhas.push(rotulo);
    }

    /* O PRESENTE POR VALOR, calculado pelo mesmo critério.

       Ele estava escrito nas listas do Liquid e aparecia na caixa solo. Saiu de
       lá; aqui entra só onde o total alcança o mínimo, e acompanha a troca de
       cor junto com o preço, que usa a MESMA conta.

       `jaTemPresente` protege contra duplicata quando alguém escreve a linha à
       mão na configuração do bloco — o mesmo cuidado que o frete toma. */
    if (this.alcancaPresente(iCaixa)) {
      var rotPresente = (this.cfg.presenteRotulo || '').trim();
      if (rotPresente) {
        var frasePresente = rotPresente + ' de presente';
        var jaTemPresente = linhas.some(function (l) {
          return l.toLowerCase().indexOf(rotPresente.toLowerCase()) !== -1;
        });
        if (!jaTemPresente) linhas.push(frasePresente);
      }
    }

    /* OS CUPONS DA CAMPANHA ENTRAM NESTA LISTA, e não numa segunda lista embaixo.

       A primeira versão pendurou os benefícios da oferta num bloco próprio no pé
       da caixa — e ficou uma caixa com DUAS listas de benefício, uma em cima
       calculada e uma embaixo fixa, dizendo coisas que se sobrepunham
       (parcelamento nas duas). O Luiz apontou olhando a tela.

       Aqui eles seguem a doutrina que este arquivo já tem escrita duas vezes
       acima: a lista diz o que é verdade para ESTA caixa, e cada linha só entra
       quando a condição dela é alcançada pelo total da caixa.

       É por isso que o VIP25 quase nunca aparece aqui: ele exige R$ 599, e nem a
       caixa do conjunto (R$ 549,80 na LipLegging) chega lá. Escrevê-lo fixo seria
       a mesma "promessa vazia" que o comentário do desconto descreve — e o lugar
       dele é a faixa da oferta, no topo da página, que fala da loja e não desta
       caixa. */
    /* O total usado aqui e o JA DESCONTADO, o mesmo que a tag de preco usa: e
       sobre ele que a Shopify avalia o minimo do cupom. Usar o total cheio numa
       das duas faria a linha e a tag discordarem sobre qual cupom vale. */
    var baseCupom = aplicaDesconto(this.linhasCaixa(iCaixa), this.cfg.desconto);
    var cupomDaCaixa = this.melhorCupom(baseCupom);
    if (cupomDaCaixa && cupomDaCaixa.texto) {
      var jaCup = linhas.some(function (l) { return l.indexOf(cupomDaCaixa.codigo) !== -1; });
      if (!jaCup) linhas.push(cupomDaCaixa.texto);
    }

    /* EXTRAS: beneficios sem minimo nenhum, entao valem em toda caixa. O
       cashback e o caso -- ele nao depende do valor do pedido, so de a compra
       ser da colecao. Frete e presente NAO estao aqui: os dois tem minimo e sao
       calculados acima, que e o que impede a caixa de R$ 359,90 prometer o que
       comeca em R$ 449,90. */
    (this.cfg.extras || []).forEach(function (x) {
      if (!x) return;
      var jaEx = linhas.some(function (l) { return l.toLowerCase() === String(x).toLowerCase(); });
      if (!jaEx) linhas.push(x);
    });

    /* O DESCONTO TAMBÉM É CALCULADO, e pelo mesmo motivo do frete.

       Eu tinha escrito a linha "15% OFF em pedidos acima de R$ 499" fixa no
       Liquid, nas DUAS caixas. Na caixa solo isso é promessa vazia: o Top Basic
       sozinho custa R$ 169,90 e nunca alcança o mínimo. A lista de itens diz o
       que a cliente LEVA naquela caixa — não o que existe na loja. Eu justifiquei
       na hora como "está escrito acima de 499, então é verdade", e é o mesmo erro
       que este arquivo já documentava duas linhas acima sobre o frete.

       Calculado, a linha aparece só onde o desconto realmente vai cair, e
       acompanha a troca de cor: se uma cor mais barata derrubar o conjunto abaixo
       do mínimo, ela sai junto com o preço cortado, que usa a MESMA conta. */
    var d = this.cfg.desconto;
    var temDesc = linhas.some(function (l) { return l.indexOf('% OFF') !== -1; });
    if (!temDesc && d && d.pct > 0 && total >= d.minimo) {
      linhas.push(d.pct + '% OFF já aplicado no preço');
    }

    /* O PARCELAMENTO TAMBÉM É CALCULADO, pelo mesmo motivo do frete.

       Aqui o número sai de `parcelasDe`, que já respeita o mínimo por parcela da
       loja. Escrito à mão, "em até 10x" continuaria na tela numa caixa barata
       onde a loja só aceita 3x — a caixa prometeria uma condição que o checkout
       não daria.

       "EM ATÉ" aqui, e não na linha embaixo do botão, é de propósito: lá o texto
       traz o VALOR da parcela, e o número é exato ("10x de R$ 37,99"). Aqui é
       benefício, sem valor — e o teto é o que a cliente quer saber. */
    var nParc = this.parcelasDe(this.precoFinalCaixa(iCaixa));
    var temParc = linhas.some(function (l) { return l.toLowerCase().indexOf('parcel') !== -1; });
    if (!temParc && nParc > 1) {
      linhas.push('Parcelamento em até ' + nParc + 'x sem juros');
    }

    return linhas;
  };

  /* As linhas da caixa, uma por peca. Existe porque o desconto e truncado por
     LINHA (ver aplicaDesconto) e a soma pronta perde essa informacao. */
  Controlador.prototype.linhasCaixa = function (iCaixa) {
    var self = this;
    var linhas = [];
    (this.caixas[iCaixa].produtos || []).forEach(function (_, iProd) {
      var v = self.varianteMostrada(iCaixa, iProd);
      if (v && typeof v.priceCents === 'number') linhas.push(v.priceCents);
    });
    return linhas;
  };

  Controlador.prototype.totalCaixa = function (iCaixa) {
    return this.linhasCaixa(iCaixa).reduce(function (a, b) { return a + b; }, 0);
  };

  Controlador.prototype.redesenhar = function () {
    var self = this;

    /* O BOTÃO DE COMPRA MORA DENTRO DA CAIXA ABERTA — e é o MESMO elemento.

       Duplicar o botão (um por caixa) duplicaria o estado: rótulo, atributo
       `disabled` e o aria-* são atualizados em `atualizar()` a partir de
       `this.elCta`, e passariam a existir em duas cópias que precisariam ser
       mantidas em sincronia. Basta uma divergência para a caixa fechada mostrar
       "Adicionar ao carrinho" habilitado enquanto a aberta está bloqueada por
       falta de tamanho.

       Então o botão é um só e MUDA DE LUGAR. O clique continua funcionando sem
       nenhuma mudança porque o listener é delegado na raiz, não no botão.

       A ORDEM DAS DUAS MOVIDAS IMPORTA. `elCaixas.innerHTML = ...` destrói tudo
       que estiver dentro, inclusive o botão que a passada anterior colocou lá.
       Por isso ele volta para a casa dele ANTES do redesenho e entra no encaixe
       da caixa aberta DEPOIS. Sem a primeira movida, o botão é destruído no
       primeiro clique em outra caixa e a página fica sem como comprar. */
    /* O PARCELAMENTO VIAJA COM O BOTÃO. Ele fica logo abaixo dele e é sobre o
       mesmo valor; deixado fora, sobraria uma linha solta embaixo das caixas
       falando do preço de uma caixa que está dois blocos acima. */
    if (!this.mudamDeLugar) {
      this.mudamDeLugar = [this.elCta, this.raiz.querySelector('[data-tp-lc-parcelas]')]
        .filter(Boolean)
        .map(function (el) { return { el: el, casa: el.parentElement }; });
    }
    this.mudamDeLugar.forEach(function (m) {
      if (m.el.parentElement !== m.casa) m.casa.appendChild(m.el);
    });

    this.elCaixas.innerHTML = this.caixas.map(function (c, i) {
      return self.caixaHTML(c, i);
    }).join('');

    this.posicionarCta();
    this.ajustarCores();
  };

  /* LEVA O BOTAO (e o parcelamento) PARA A CAIXA ABERTA.

     Precisa ser uma funcao propria porque ha DOIS momentos em que o destino
     muda, e so um deles redesenha o DOM:

     - `redesenhar()` reconstroi as caixas (troca de cor, de versao) e o encaixe
       anterior deixa de existir;
     - `escolherCaixa()` NAO reconstroi nada -- so alterna a classe `is-aberta`
       e atualiza os valores. Foi por isso que a primeira versao falhou: o
       encaixe era emitido so na caixa aberta, na renderizacao inicial, e clicar
       na segunda caixa nao movia o botao (o encaixe continuava na primeira).

     Por isso o encaixe existe em TODAS as caixas e quem escolhe e esta funcao,
     pelo indice -- nao pelo primeiro que o querySelector achar. */
  Controlador.prototype.posicionarCta = function () {
    if (!this.mudamDeLugar) return;
    var encaixe = this.elCaixas.querySelector('[data-tp-lc-cta-slot="' + this.atual + '"]');
    if (!encaixe) return;
    this.mudamDeLugar.forEach(function (m) { encaixe.appendChild(m.el); });
  };

  /* FILEIRA DE CORES (16/10/2026). Com Mirtilo e Cacau o Top Basic tem 8 cores e, no celular, a 8a caia
     sozinha numa segunda linha. Diminuir as bolinhas esta fora (Guilherme: fica dificil de tocar). Entao,
     quando a fileira quebra: 1) aperta so o espaco entre as bolinhas (8 -> 5 px; em 375 px as 8 cabem);
     2) se nem assim couber (celular estreito), vira duas linhas equilibradas (8 = 4+4). Fileira escondida
     (caixa fechada, largura 0) fica para quando abrir: roda no redesenho, ao escolher caixa e no resize. */
  Controlador.prototype.ajustarCores = function () {
    [].slice.call(this.raiz.querySelectorAll('.tp-lc__cores')).forEach(function (cont) {
      var k = cont.children;
      cont.classList.remove('tp-lc__cores--justa', 'tp-lc__cores--grade');
      cont.style.gridTemplateColumns = '';
      if (cont.classList.contains('tp-lc__cores--2l')) return;
      if (k.length < 2 || !cont.offsetWidth) return;
      var quebra = function () { return k[k.length - 1].offsetTop > k[0].offsetTop + 2; };
      if (!quebra()) return;
      cont.classList.add('tp-lc__cores--justa');
      if (!quebra()) return;
      cont.classList.remove('tp-lc__cores--justa');
      cont.style.gridTemplateColumns = 'repeat(' + Math.ceil(k.length / 2) + ', 34px)';
      cont.classList.add('tp-lc__cores--grade');
    });
  };

  Controlador.prototype.montar = function () {
    this.redesenhar();
    this.ligar();
    this.atualizar();
    var self = this, tCores = null;
    window.addEventListener('resize', function () {
      clearTimeout(tCores);
      tCores = setTimeout(function () { self.ajustarCores(); }, 150);
    });
  };

  Controlador.prototype.caixaHTML = function (c, i) {
    var self = this;
    var aberta = i === this.atual;
    var itens = this.itensDaCaixa(i);
    var presentes = this.presentesDaCaixa(i);

    var temEtiqueta = !!(c.tag || c.cronometro);
    var h = '<div class="tp-lc__caixa' + (aberta ? ' is-aberta' : '') + (temEtiqueta ? ' tem-tag' : '') + '" data-tp-lc-caixa="' + i + '">';

    /* Etiqueta montada na borda de cima, metade dentro e metade fora. Nao e o
       mesmo papel do selo: o selo compara ("mais escolhido"), a etiqueta nomeia
       ("conjunto"). Mesmo lugar e mesma cor confundiriam os dois.

       COM CRONOMETRO, a pilula deixa de nomear e passa a contar. E a MESMA
       pilula: mesmo lugar, mesmo verde, mesma fonte - so o conteudo muda. Foi o
       pedido ("nenhuma firula"), e tambem o que faz caber: as pastilhas do
       tp-relogio tem numeros de 1.4rem sobre fundo verde, e aqui elas ficariam
       verde sobre verde dentro de uma pilula de 10px.

       Os tres <span> levam os mesmos data-tp-cdc-h/m/s que o tp-relogio usa,
       entao quem atualiza e o tp-countdown.js de sempre - sem segundo relogio
       no tema. O `data-tp-cdc-reinicia` e o que faz a caixa NAO sumir no fim do
       prazo: ver o comentario no tp-countdown.js.

       O tp-countdown.js consulta o DOM a cada tique (esta documentado la), por
       isso ele acha esta pilula mesmo tendo sido desenhada aqui depois de o
       script ter carregado. */
    if (c.cronometro) {
      var cr = c.cronometro;
      /* NUMERO e UNIDADE em elementos separados, como o tp-relogio faz. E o que
         faz a pilula parecer um relogio: com tudo do mesmo tamanho e em caixa
         alta ("56H 08MIN 47S"), o olho le um codigo, nao um tempo. O CSS deixa
         o digito grande e a unidade pequena e minuscula. */
      h += '<span class="tp-lc__tag tp-lc__tag--cron" data-tp-cdc data-tp-cdc-reinicia' +
        ' data-fim="' + attr(cr.fim) + '" role="timer" aria-live="off">' +
        '<span class="tp-lc__cron-g"><span data-tp-cdc-h>' + dd(cr.h) + '</span><span class="tp-lc__cron-un">h</span></span>' +
        '<span class="tp-lc__cron-g"><span data-tp-cdc-m>' + dd(cr.m) + '</span><span class="tp-lc__cron-un">min</span></span>' +
        '<span class="tp-lc__cron-g"><span data-tp-cdc-s>' + dd(cr.s) + '</span><span class="tp-lc__cron-un">s</span></span>' +
        '</span>';
    } else if (c.tag) {
      h += '<span class="tp-lc__tag">' + esc(c.tag) + '</span>';
    }

    /* O cabeçalho inteiro é o alvo do clique, não só a bolinha. Alvo pequeno é
       o que faz a cliente errar duas vezes antes de acertar no celular. */
    h += '<button type="button" class="tp-lc__cabeca" data-tp-lc-escolher="' + i + '" aria-pressed="' + (aberta ? 'true' : 'false') + '">';
    h += '<span class="tp-lc__radio" aria-hidden="true"></span>';
    h += '<span class="tp-lc__cabeca-texto">';
    h += '<span class="tp-lc__titulo">' + esc(this.tituloDaCaixa(i)) + '</span>';
    /* PRECO E CHIP DO CUPOM NA MESMA LINHA.

       O chip nao diz mais um preco -- diz o CODIGO do preco que esta ali do
       lado. Numa linha propria embaixo do parcelado ele ficaria a duas linhas
       do numero que nomeia, e a cliente teria de voltar para ligar os dois.
       Junto, a linha se le inteira: "de X por Y com o cupom Z". */
    h += '<span class="tp-lc__preco-linha">';
    h += '<span class="tp-lc__preco" data-tp-lc-preco="' + i + '"></span>';
    h += '<span class="tp-lc__cupom" data-tp-lc-cupom="' + i + '"></span>';
    h += '</span>';
    /* O parcelado de CADA caixa, embaixo do preço dela. Uma linha só embaixo do
       botão só dizia o parcelado da caixa aberta, e era justamente na fechada
       que ele fazia falta: o salto de R$ 379,90 para R$ 569,80 assusta menos
       lido como 6x de R$ 63 contra 6x de R$ 94. */
    h += '<span class="tp-lc__parcela" data-tp-lc-parcela="' + i + '"></span>';
    h += '</span>';
    /* Um icone de presente POR brinde, no coral do botao. Numero escrito
       ("2 presentes") a cliente le; icone repetido ela CONTA sem ler — e a
       diferenca entre as duas caixas passa a ser visivel de relance, que e o
       trabalho da caixa fechada. */
    var nPresentes = presentes.length;
    /* Canto superior direito, fora da linha do título: ali eles não disputam
       largura com o nome, e as duas caixas ficam comparáveis pelo mesmo ponto da
       tela. Presentes em cima, selo embaixo. */
    if (nPresentes || c.selo) h += '<span class="tp-lc__canto">';
    if (nPresentes) {
      h += '<span class="tp-lc__presentes" aria-label="' + nPresentes + ' presente' + (nPresentes > 1 ? 's' : '') + '">';
      for (var g = 0; g < nPresentes; g++) {
        h += iconePresente('tp-lc__presente-icone');
      }
      h += '</span>';
    }
    if (c.selo) h += '<span class="tp-lc__selo">' + esc(c.selo) + '</span>';
    if (nPresentes || c.selo) h += '</span>';
    h += '</button>';

    /* Os ITENS ficam sempre visiveis; so os seletores de tamanho aparecem na
       caixa escolhida. E o que a caixa fechada precisa dizer para ser comparada
       ("o que eu levo?"), e o que ela nao precisa e o formulario — que era o que
       ocupava a tela toda antes. */
    h += '<div class="tp-lc__corpo">';

    /* VITRINE: o que vem na caixa, com foto.

       Peças e presentes na mesma fileira, porque para a cliente é tudo "o que
       chega". O que separa os dois é o preço embaixo — a peça mostra quanto
       custa, o presente mostra Grátis. Sem esse rótulo, a fileira viraria uma
       lista de produtos e o presente perderia o que ele tem de melhor. */
    /* A FOTO SEGUE A COR ESCOLHIDA.

       Prioridade: foto da variante > foto vinculada à cor > primeira foto do
       produto. A da variante é a mais específica e é a que o carrinho vai
       mostrar; a da cor cobre o caso de o tamanho ainda não estar escolhido. */
    var vitrine = (c.produtos || []).map(function (p, iProd) {
      var v = self.varianteMostrada(i, iProd);
      var cor = self.corDe(i, iProd);
      var daCor = '';
      self.cores(p).forEach(function (cc) { if (cc.name === cor && cc.img) daCor = cc.img; });
      return {
        titulo: p.title,
        imagem: miniatura((v && v.image) || daCor || (p.images && p.images[0]) || ''),
        valor: v && typeof v.priceCents === 'number' ? dinheiro(v.priceCents) : '',
        presente: false,
        zoom: false
      };
    }).concat(presentes.map(function (g) {
      return { titulo: g.titulo, imagem: g.imagem, valor: 'Grátis', presente: true, zoom: !!g.zoom };
    })).filter(function (x) { return x.imagem; });

    if (vitrine.length) {
      h += '<div class="tp-lc__vitrine">';
      vitrine.forEach(function (x) {
        h += '<figure class="tp-lc__vit' + (x.presente ? ' is-presente' : '') + '">';
        /* Sem `loading="lazy"`.

           Estas imagens entram na página DEPOIS do carregamento, montadas por
           este script — e o navegador não reavalia o lazy para nós injetados
           assim. Ficavam permanentemente em branco, mesmo já dentro da tela;
           conferi que era isso removendo o atributo na mão e a foto apareceu na
           hora. Além disso são 200px dentro da caixa de compra: conteúdo
           principal, não algo que valha adiar. */
        /* `data-tp-zoom` é o contrato do lightbox global do tema
           (assets/tp-lightbox.js), que escuta por delegação e por isso pega
           também estas fotos, que nascem depois do carregamento. Ele pede a
           versão em 1800px ao abrir — então a foto ampliada mostra a peça
           inteira, mesmo quando a miniatura está aproximada. */
        /* A foto vai dentro de um invólucro próprio porque a miniatura
           aproximada precisa ser recortada, e recortar no <figure> cortaria o
           nome e o preço junto. */
        h += '<span class="tp-lc__vit-foto">';
        h += '<img class="tp-lc__vit-img' + (x.zoom ? ' is-aproximada' : '') +
          '" src="' + attr(x.imagem) + '" alt="' + attr(x.titulo) + '" width="72" height="72" data-tp-zoom>';
        h += '</span>';
        /* Laço no canto da miniatura, FORA do invólucro da foto: aquele recorta
           (é o que segura a aproximação do chaveiro), e dentro dele o laço
           nasceria cortado pela metade. O <figure> não recorta, então o selo
           pode encostar na borda e vazar um pouco. */
        if (x.presente) h += '<span class="tp-lc__vit-selo">' + iconePresente('tp-lc__vit-selo-icone') + '</span>';
        h += '<figcaption class="tp-lc__vit-txt">';
        h += '<span class="tp-lc__vit-nome">' + esc(x.titulo) + '</span>';
        h += '<span class="tp-lc__vit-valor">' + esc(x.valor) + '</span>';
        h += '</figcaption></figure>';
      });
      h += '</div>';
    }

    if (itens.length) {
      h += '<ul class="tp-lc__itens">';
      itens.forEach(function (t) {
        h += '<li class="tp-lc__item"><span class="tp-lc__check" aria-hidden="true">' +
          '<svg viewBox="0 0 14 14" fill="none"><path d="M3 7.2L5.6 9.8L11 4.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</span>' + esc(t) + '</li>';
      });
      h += '</ul>';
    }

    /* A CONDIÇÃO DO PRESENTE FICA NA TELA O TEMPO TODO.

       As linhas de item somem quando a cor muda (ver itensDaCaixa), e faz
       sentido: prometer "faixa Bosque de presente" com Preto selecionado seria
       mentira. Só que sumir também esconde a OFERTA — quem abre a página em
       Preto nunca descobre que existe presente escolhendo Bosque.

       Esta frase resolve os dois: ela carrega a condição no próprio texto, então
       nunca mente, e por isso não passa pelo filtro de cor. Ela é convite, não
       confirmação — o que a cliente já ganhou continua sendo dito pelas linhas
       de item e pela fileira de presentes.

       A bolinha é a mesma do swatch da cor, e é ela que faz a ligação com o
       seletor logo abaixo sem precisar de mais uma palavra. */
    var nota = String(c.nota || '').trim();
    if (nota) {
      var estiloNota = self.corAlvoSwatch(i);
      h += '<p class="tp-lc__nota">' +
        '<span class="tp-lc__nota-bolha"' +
        (estiloNota ? ' style="' + attr(estiloNota) + '"' : '') +
        ' aria-hidden="true"></span>' +
        '<span>' + esc(nota) + '</span>' +
        '</p>';
    }

    h += '</div>';

    h += '<div class="tp-lc__selecao" data-tp-lc-corpo="' + i + '"' + (aberta ? '' : ' hidden') + '>';
    (c.produtos || []).forEach(function (p, iProd) {
      var corAtual = self.corDe(i, iProd);
      var tams = self.tamanhos(p, corAtual);
      if (!tams.length) return;
      h += '<div class="tp-lc__peca">';
      h += self.versaoHTML(i, iProd);
      h += '<div class="tp-lc__peca-topo">';
      h += '<span class="tp-lc__peca-nome">' + esc(nomeDaPeca(c, iProd)) + '</span>';
      /* Guia de medidas POR PEÇA, e ao lado do seletor dela. Um link só, no
         rodapé da caixa, obrigaria a cliente a adivinhar de qual peça é a
         tabela que abriu. */
      /* TRÊS BOTÕES, um por conteúdo, em vez de um link que abre tudo empilhado.

         Juntar as três coisas num modal só virou uma lista longa: tabela,
         explicação de como medir e fotos das modelos, uma embaixo da outra. Quem
         queria ver a modelo tinha de rolar por duas tabelas para chegar lá — e
         ninguém rola. Agora cada botão abre o pop-up já no conteúdo dele, e
         dentro do pop-up os mesmos três trocam sem fechar. */
      var abas = self.abasDaPeca(p);
      if (abas.length) {
        h += '<span class="tp-lc__abas">';
        abas.forEach(function (ab) {
          h += '<button type="button" class="tp-lc__guia" data-tp-lc-guia="' + i + '-' + iProd + '-' + ab.id + '">' + esc(ab.rotulo) + '</button>';
        });
        h += '</span>';
      }
      h += '</div>';

      /* CORES, quando a peça tem mais de uma.

         Vem ANTES do tamanho de propósito: a cor muda quais tamanhos existem e
         quanto custa, então perguntar tamanho primeiro seria pedir uma resposta
         que a pergunta seguinte pode invalidar.

         Peça de cor única não ganha seletor — um botão com uma opção só é uma
         decisão inventada. */
      var cores = self.cores(p);
      if (cores.length > 1) {
        /* A cor do lançamento é a única limitada. O ponto na bolinha diz isso
           ANTES de ela ser escolhida — sem ele, quem abrisse a página já em
           outra cor nunca saberia que existe uma acabando. */
        var corAlvo = (self.cfg.cor || '').trim();
        var corTag = (self.cfg.corTag || '').trim();
        /* CORES EM DUAS LINHAS (19/10/2026, Guilherme): as de sempre em cima (Preto, Cereja, Cafe, Azul Marinho),
           as novas embaixo (Branco, Bosque, Mirtilo, Cacau), linha fina entre elas. So quando todas as cores sao
           dessas listas e ha 3+ classicas e 2+ novas; senao a fileira fica como era. Mesma regra da Oferta B. */
        var CLASSICAS = ['preto', 'cereja', 'cafe', 'azul marinho'], NOVAS = ['branco', 'bosque', 'mirtilo', 'cacau'];
        var semAc = function (t) { return String(t || '').normalize ? String(t).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim() : String(t).toLowerCase().trim(); };
        var cAnt = [], cNov = [], cFora = false;
        cores.forEach(function (cc) { var n = semAc(cc.name); if (CLASSICAS.indexOf(n) > -1) cAnt.push(cc); else if (NOVAS.indexOf(n) > -1) cNov.push(cc); else cFora = true; });
        var duas = !cFora && cAnt.length >= 3 && cNov.length >= 2;
        if (duas) cNov.sort(function (a, b) { return (semAc(a.name) === 'branco' ? 0 : 1) - (semAc(b.name) === 'branco' ? 0 : 1); });
        var ordem = duas ? cAnt.concat([null], cNov) : cores;
        h += '<div class="tp-lc__cores' + (duas ? ' tp-lc__cores--2l' : '') + '" role="group" aria-label="Cor: ' + attr(p.title) + '">';
        ordem.forEach(function (cc) {
          if (!cc) { h += '<span class="tp-lc__cor-quebra">Novas cores</span>'; return; }
          var limitada = corTag && cc.name === corAlvo;
          var estilo = estiloSwatch(cc);
          var rotulo = cc.name + (limitada ? ' · ' + corTag : '');
          h += '<button type="button" class="tp-lc__cor' + (cc.name === corAtual ? ' is-escolhida' : '') +
            (limitada ? ' is-limitada' : '') + '"' +
            ' data-tp-lc-cor="' + i + '-' + iProd + '" data-valor="' + attr(cc.name) + '"' +
            ' title="' + attr(rotulo) + '" aria-label="' + attr(rotulo) + '"' +
            ' aria-pressed="' + (cc.name === corAtual ? 'true' : 'false') + '">' +
            '<span class="tp-lc__cor-bolha"' + (estilo ? ' style="' + attr(estilo) + '"' : '') + '></span>' +
            '</button>';
        });
        h += '</div>';
        h += '<p class="tp-lc__cor-nome">' + esc(corAtual || '');
        if (corTag && corAtual === corAlvo) {
          h += '<span class="tp-lc__cor-tag">' + esc(corTag) + '</span>';
        }
        h += '</p>';
      }

      h += '<div class="tp-lc__tamanhos">';
      /* `is-escolhido` sai do ESTADO, não de quem clicou. Trocar a cor de uma
         peça redesenha a caixa toda, e a peça vizinha perderia o destaque do
         tamanho que a cliente já tinha escolhido — o estado continuava certo, só
         a tela é que mentia. */
      var tamEscolhido = self.sel[i][iProd];
      tams.forEach(function (t) {
        var v = self.variantePorTamanho(p, t, corAtual);
        var indisp = !v || !v.available;
        h += '<button type="button" class="tp-lc__tamanho' + (indisp ? ' is-indisponivel' : '') +
          (t === tamEscolhido ? ' is-escolhido' : '') + '"' +
          ' data-tp-lc-tam="' + i + '-' + iProd + '" data-valor="' + attr(t) + '"' +
          '>' + esc(t) + '</button>'; // AVISE-ME (19/10/2026): esgotado continua clicável (sem disabled)
      });
      h += '</div></div>';
    });

    /* O ENCAIXE DO BOTÃO — DENTRO do `__corpo`, e é aqui que estava o defeito.

       Eu havia emitido este div DEPOIS do `</div>` de baixo, e aquele `</div>`
       é o que FECHA o corpo. O encaixe virava filho direto de `.tp-lc__caixa`,
       que tem `padding: 0` -- então o botão encostava nas três bordas do cartão
       a 1px de cada, e o parcelado grudava na borda de baixo. Nenhum ajuste de
       tamanho de fonte corrigia isso, e eu perdi duas rodadas mexendo em fonte
       antes de conferir o PAI do elemento no DOM (`corpo.contains(enc)` devolveu
       false, e foi isso que resolveu a dúvida).

       Dentro do corpo ele herda o `padding: 0 16px 16px`, que é o mesmo respiro
       da vitrine e dos seletores logo acima.

       No fim do corpo, e não antes: acima ficam o que vem na caixa e os
       seletores de tamanho: o botão só faz sentido depois de as escolhas
       estarem na tela.

       Emitido em TODAS as caixas (não só na aberta) porque trocar de caixa não
       redesenha o DOM -- quem escolhe o destino é `posicionarCta`, pelo índice. */
    h += '<div class="tp-lc__cta-encaixe" data-tp-lc-cta-slot="' + i + '"></div>';

    h += '</div>';

    h += '</div>';
    return h;
  };

  /* UM listener na raiz, por delegação, em vez de um por botão.

     Trocar de cor reescreve a caixa inteira (fotos, presentes, tamanhos), e com
     listeners presos a cada botão isso significaria religar tudo a cada clique —
     ou pior, esquecer de religar um deles e ter um botão morto na tela. Por
     delegação, a marcação pode ser reescrita à vontade. */
  Controlador.prototype.ligar = function () {
    var self = this;

    this.raiz.addEventListener('click', function (ev) {
      var alvo;

      if (ev.target.closest('[data-tp-lc-cta]')) { self.adicionar(); return; }

      if ((alvo = ev.target.closest('[data-tp-lc-cor]'))) {
        var pc = alvo.dataset.tpLcCor.split('-');
        self.escolherCor(parseInt(pc[0], 10), parseInt(pc[1], 10), alvo.dataset.valor);
        return;
      }

      if ((alvo = ev.target.closest('[data-tp-lc-tam]'))) {
        var pt = alvo.dataset.tpLcTam.split('-');
        self.escolherTamanho(parseInt(pt[0], 10), parseInt(pt[1], 10), alvo.dataset.valor);
        return;
      }

      if ((alvo = ev.target.closest('[data-tp-lc-guia]'))) {
        var pg = alvo.dataset.tpLcGuia.split('-');
        self.abrirGuia(parseInt(pg[0], 10), parseInt(pg[1], 10), pg[2]);
        return;
      }

      /* Antes do clique na caixa: o botão de versão vive dentro dela, e a caixa
         inteira é clicável para escolher. Sem sair aqui, trocar de versão também
         selecionaria a caixa. */
      if ((alvo = ev.target.closest('[data-tp-lc-versao]'))) {
        var pv = alvo.dataset.tpLcVersao.split('-');
        self.trocarVersao(parseInt(pv[0], 10), parseInt(pv[1], 10));
        return;
      }

      if ((alvo = ev.target.closest('[data-tp-lc-escolher]'))) {
        self.escolherCaixa(parseInt(alvo.dataset.tpLcEscolher, 10));
        return;
      }

      /* A CAIXA INTEIRA escolhe, não só o cabeçalho.

         A cliente lê a fileira de fotos e a lista do que vem, decide ali, e
         clicava no meio disso sem nada acontecer — o alvo era só a primeira
         linha. Agora qualquer ponto morto do cartão seleciona.

         Ampliar a foto é a única exceção que sobra aqui: os controles com ação
         própria já saíram acima com `return`. Sem isto, clicar no chaveiro para
         vê-lo de perto também trocaria a caixa escolhida. */
      if (ev.target.closest('[data-tp-zoom]')) return;
      if ((alvo = ev.target.closest('[data-tp-lc-caixa]'))) {
        self.escolherCaixa(parseInt(alvo.dataset.tpLcCaixa, 10));
      }
    });

    document.querySelectorAll('[data-tp-lc-sg-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        var m = document.querySelector('[data-tp-lc-sg]');
        if (m) m.hidden = true;
      });
    });
  };

  /* ABRE E FECHA COM ALTURA MEDIDA, não com `hidden` seco.

     `height` não anima a partir de `auto` — o navegador não tem para onde
     interpolar. Então: mede a altura real do conteúdo, fixa esse número, e
     deixa a transição correr até ele. No fim, devolve `auto`, senão o bloco
     ficaria travado numa altura fixa e quebraria se o conteúdo mudasse (peça
     esgotada, tamanho a mais).

     Fechar é o inverso, com um detalhe que sempre pega: partindo de `auto`, é
     preciso fixar a altura atual e forçar o navegador a assumi-la ANTES de
     mandar para zero. Sem esse passo, as duas mudanças caem no mesmo quadro e
     ele pula direto para o fim — que é exatamente o "brusco" de antes.

     `overflow: hidden` durante o movimento evita o conteúdo vazar para fora da
     caixa enquanto ela ainda é mais baixa que ele. */
  function animar(el, abrir) {
    if (el._tpAnim) clearTimeout(el._tpAnim);
    var DUR = 260;

    if (abrir) {
      el.hidden = false;
      el.style.overflow = 'hidden';
      el.style.height = '0px';
      // Ler offsetHeight força o navegador a assumir o 0 antes de ir para o alvo.
      void el.offsetHeight;
      el.style.transition = 'height ' + DUR + 'ms cubic-bezier(0.22, 1, 0.36, 1), opacity ' + DUR + 'ms ease';
      el.style.opacity = '1';
      el.style.height = el.scrollHeight + 'px';
      el._tpAnim = setTimeout(function () {
        el.style.height = 'auto';
        el.style.overflow = '';
        el.style.transition = '';
      }, DUR);
    } else {
      if (el.hidden) return;
      el.style.overflow = 'hidden';
      el.style.height = el.scrollHeight + 'px';
      void el.offsetHeight;
      el.style.transition = 'height ' + DUR + 'ms cubic-bezier(0.22, 1, 0.36, 1), opacity ' + DUR + 'ms ease';
      el.style.height = '0px';
      el.style.opacity = '0';
      el._tpAnim = setTimeout(function () {
        el.hidden = true;
        el.style.height = '';
        el.style.opacity = '';
        el.style.overflow = '';
        el.style.transition = '';
      }, DUR);
    }
  }

  Controlador.prototype.escolherCaixa = function (i) {
    if (i === this.atual) return;
    this.atual = i;
    var self = this;
    this.raiz.querySelectorAll('[data-tp-lc-caixa]').forEach(function (el, k) {
      el.classList.toggle('is-aberta', k === i);
      var corpo = el.querySelector('[data-tp-lc-corpo]');
      if (corpo) animar(corpo, k === i);
      var cab = el.querySelector('[data-tp-lc-escolher]');
      if (cab) cab.setAttribute('aria-pressed', k === i ? 'true' : 'false');
    });
    this.posicionarCta();
    this.ajustarCores();
    this.atualizar();
    this.mostrarNaGaleria(i, 0, false);
  };

  /* Trocar de cor mexe em tudo que a caixa promete: foto, preço, tamanhos
     disponíveis e presentes. Por isso redesenha as caixas inteiras em vez de
     remendar nó por nó — é uma operação por clique, e o custo de esquecer um
     pedaço (a foto certa com o presente errado) é a cliente vendo uma promessa
     que o carrinho não cumpre. */
  Controlador.prototype.escolherCor = function (iCaixa, iProd, cor) {
    var p = this.caixas[iCaixa].produtos[iProd];
    if (!p || this.corDe(iCaixa, iProd) === cor) return;
    this.cor[iCaixa][iProd] = cor;

    // O tamanho escolhido pode não existir — ou estar esgotado — na cor nova.
    this.sel[iCaixa][iProd] = null;

    this.redesenhar();
    this.atualizar();
    // 16/10/2026 (Guilherme): escolher a cor NAO rola a pagina ate a galeria (era `true`, que no celular fazia scrollIntoView)
    this.mostrarNaGaleria(iCaixa, iProd, false);
  };

  Controlador.prototype.escolherTamanho = function (iCaixa, iProd, valor) {
    this.sel[iCaixa][iProd] = valor;
    this.raiz.querySelectorAll('[data-tp-lc-tam="' + iCaixa + '-' + iProd + '"]').forEach(function (b) {
      b.classList.toggle('is-escolhido', b.dataset.valor === valor);
    });
    this.atualizar();
    /* Mexer no tamanho de uma peca tambem e dizer "estou olhando esta". */
    this.mostrarNaGaleria(iCaixa, iProd, false);
  };

  /* Estado do botão. A mensagem diz o que FALTA, com o nome da peça: num
     conjunto de duas, "Selecione o tamanho" sozinho não diz de qual. */
  /* ETIQUETA DE EDIÇÃO LIMITADA SOBRE A FOTO.

     A caixa já mostra a etiqueta ao lado do NOME da cor. O CSS da página quer a
     mesma informação para desenhar a pílula no canto da foto, e não tem como
     descobri-la sozinho: nesta página o seletor de cor é o da caixa, não o
     `product-variant-picker`, então não existe `input[data-limitada]:checked`
     para o `:has()` alcançar.

     O sinal precisa ser a cor do PRODUTO PRINCIPAL, não qualquer cor limitada na
     tela. `this.cor[0][0]` é a caixa de uma peça, primeiro produto — que é o
     produto da página, o mesmo da galeria. Usar "existe alguma etiqueta na
     caixa" acenderia a pílula quando a cliente escolhesse Bosque só na peça
     PARCEIRA dentro do conjunto, e a foto ao lado seria de outra cor.

     Vai como atributo na raiz, não como classe no `.product`: mantém o
     controlador mexendo só no que é dele, e o CSS chega lá por `:has()`. */
  Controlador.prototype.marcarCorLimitada = function () {
    var alvo = (this.cfg.cor || '').trim();
    var atual = ((this.cor[0] || [])[0] || '').trim();
    var limitada = !!alvo && !!this.cfg.corTag && atual === alvo;
    this.raiz.setAttribute('data-cor-limitada', limitada ? '1' : '0');
  };

  Controlador.prototype.atualizar = function () {
    var self = this;
    this.marcarCorLimitada();
    this.caixas.forEach(function (c, i) {
      var total = self.totalCaixa(i);
      var el = self.raiz.querySelector('[data-tp-lc-preco="' + i + '"]');
      if (el) {
        /* PRECO CORTADO quando o desconto da campanha alcanca ESTA caixa.

           A checagem do minimo e por caixa, nao por produto: as duas caixas da
           mesma pagina tem totais diferentes, e a solo das pecas baratas nao
           chega nos R$ 499 (Top Basic sozinho e R$ 169,90). Riscar ali seria
           prometer um desconto que o checkout nao daria.

           A conta e a MESMA do tp-campanha-economia: `total * pct / 100` com
           truncamento inteiro, que e como a Shopify arredonda. Conferido contra
           draftOrderCalculate: 35990 -> 30592. Nao trocar por arredondamento
           meio-para-cima, senao a tela divergiria do carrinho em um centavo. */
        var comDesc = aplicaDesconto(self.linhasCaixa(i), self.cfg.desconto);

        /* O CUPOM ENTRA NO PRECO DA CAIXA, e nao numa tag separada embaixo.

           Antes o preco mostrava um numero e a tag verde embaixo mostrava
           outro. Sao o mesmo preco em dois lugares, e a cliente tinha de
           juntar: o de cima era o que ela NAO paga, o de baixo o que ela paga.
           Agora a comparacao acontece onde o preco esta -- cortado o valor sem
           cupom, em destaque o valor com ele -- e a tag ao lado carrega so o
           nome do codigo.

           Precedencia: se ha cupom aplicavel a esta caixa, ele manda, porque e
           o menor valor que ela pode pagar. Sem cupom, cai no desconto de
           campanha (o comportamento de antes), e sem nenhum dos dois, no preco
           simples. */
        var cupPreco = self.melhorCupom(comDesc);
        if (cupPreco) {
          el.innerHTML = '<s class="tp-lc__preco-de">' + esc(dinheiro(comDesc)) + '</s>' +
            '<span class="tp-lc__preco-por">' + esc(dinheiro(self.precoFinalCaixa(i))) + '</span>';
        } else if (comDesc < total) {
          el.innerHTML = '<s class="tp-lc__preco-de">' + esc(dinheiro(total)) + '</s>' +
            '<span class="tp-lc__preco-por">' + esc(dinheiro(comDesc)) + '</span>';
        } else {
          el.textContent = dinheiro(total);
        }
      }
      var elP = self.raiz.querySelector('[data-tp-lc-parcela="' + i + '"]');
      /* O parcelado segue o preco QUE A CLIENTE VAI PAGAR -- incluindo o cupom,
         que e o numero em destaque logo acima. Parar no desconto de campanha
         deixava a caixa dizendo "R$ 287,92" e "9x de R$ 39,98" (359,90/9) em
         linhas vizinhas. */
      if (elP) elP.textContent = self.textoParcela(self.precoFinalCaixa(i));

      /* O PRECO COM O CUPOM, por caixa.

         Na PDP comum esta tag mora embaixo do preco, no cabecalho do produto.
         Aqui nao existe aquele cabecalho: o preco de cada caixa e escrito por
         este JS, e sao DOIS precos na mesma tela. Uma tag so, fora das caixas,
         teria de escolher qual dos dois descontar -- e a caixa que ficasse sem
         ela pareceria nao ter direito ao cupom.

         A conta parte do preco JA DESCONTADO (`aplicaDesconto`), que e o que a
         cliente paga antes do cupom. Sobre o total cheio a tag prometeria menos
         desconto do que o checkout dara, e sobre um numero que a tela nao mostra
         em lugar nenhum.

         `+ 50` antes de dividir por 100 arredonda para o centavo mais proximo,
         a mesma conta do card da vitrine e da PDP -- truncado, as tres telas
         divergiriam em um centavo entre si. */
      /* A TAG CARREGA SO O NOME DO CUPOM. Os dois valores ja estao no preco
         logo acima; repeti-los aqui era dizer o mesmo preco duas vezes na
         mesma caixa. O que a tag adiciona e o CODIGO -- a unica parte que a
         cliente precisa levar consigo para o checkout. */
      var elC = self.raiz.querySelector('[data-tp-lc-cupom="' + i + '"]');
      if (elC) {
        var cup = self.melhorCupom(aplicaDesconto(self.linhasCaixa(i), self.cfg.desconto));
        elC.innerHTML = cup
          ? 'com o cupom <span class="tp-lc__cupom-cod">' + esc(cup.codigo) + '</span>'
          : '';
      }
    });

    var caixa = this.caixas[this.atual];
    var faltando = null;
    (caixa.produtos || []).forEach(function (p, iProd) {
      if (faltando) return;
      var cor = self.corDe(self.atual, iProd);
      if (self.tamanhos(p, cor).length && !self.sel[self.atual][iProd]) faltando = nomeDaPeca(caixa, iProd);
    });

    /* AVISE-ME (19/10/2026): tamanho esgotado escolhido -> o botão fica ativo e só troca o texto */
    var esg = faltando ? null : this.esgotadoEscolhido();
    if (this.elCta) this.elCta.disabled = !!faltando;
    if (this.elCtaLabel) {
      this.elCtaLabel.textContent = faltando
        ? 'Escolha o tamanho: ' + faltando
        : esg ? (window.tpAviseMe ? window.tpAviseMe.rotulo(esg.v.id) : 'Avise-me quando chegar')
        : (this.cfg.cta || 'Adicionar ao carrinho');
    }

    /* A linha embaixo do botão fala da caixa ESCOLHIDA, que é o que o botão vai
       comprar. O parcelado de dentro de cada caixa continua existindo para
       comparar as duas antes de decidir. */
    if (this.elParcelas) {
      /* Mesmo numero da caixa aberta, pelo mesmo helper: duas parcelas
         diferentes na mesma tela para o mesmo botao seria pior que nao mostrar
         nenhuma. */
      this.elParcelas.textContent = this.textoParcela(this.precoFinalCaixa(this.atual));
    }
  };

  /* Quantas parcelas cabem neste total, pela mesma regra do tp-installments. */
  Controlador.prototype.parcelasDe = function (total) {
    if (!this.parcLigado || !(total > 0)) return 0;
    // Override do metacampo: número direto, sem checar mínimo. 1x = à vista.
    if (this.parcOverride > 1) return this.parcOverride;
    if (this.parcOverride === 1) return 0;
    // Configuração do tema: desce do maior até achar parcela acima do mínimo.
    for (var n = this.parcTema; n >= 2; n--) {
      if (Math.floor(total / n) >= this.parcMinima) return n;
    }
    return 0;
  };

  Controlador.prototype.textoParcela = function (total) {
    var n = this.parcelasDe(total);
    if (!n) return '';
    return n + 'x de ' + dinheiro(Math.floor(total / n)) + ' sem juros';
  };

  /* Quais abas esta peça tem. Só entra a que tem conteúdo — peça sem tabela de
     medidas não ganha um botão que abre vazio.

     Rótulos curtos porque são três lado a lado dentro da caixa: no celular,
     "Tabela de medidas" sozinho já quebraria a linha. */
  Controlador.prototype.abasDaPeca = function (p) {
    var abas = [];
    if (p.sizeGuide) abas.push({ id: 'tabela', rotulo: 'Tabela', html: p.sizeGuide });
    if (p.medidasPeca) abas.push({ id: 'peca', rotulo: 'Medidas da peça', html: p.medidasPeca });
    if (p.modelosReais) abas.push({ id: 'modelos', rotulo: 'Modelos', html: p.modelosReais });
    return abas;
  };

  /* ------------------------------------------------------------------
     A GALERIA SEGUE A PEÇA E A COR ESCOLHIDAS
     ------------------------------------------------------------------
     A página vende até quatro peças (as duas da dupla e as versões com bolso
     de cada uma), e a cliente escolhe a cor de cada uma sem sair da página. A
     galeria do topo tem de mostrar o que ela acabou de escolher, senão a foto
     desmente o seletor.

     As fotos de todas as peças já estão na mesma <ul>, escondidas, vindas do
     Liquid (ver tp-lc-galeria-extra.liquid). Aqui só mostro e escondo. O
     slider do Dawn conta as páginas filtrando slide de largura zero, então
     basta chamar o `resetPages` dele depois.

     Os slides da peça DA PÁGINA vêm do laço do Dawn e não têm marca de cor —
     marcá-los no Liquid exigiria mexer nesse laço, que é o arquivo de todos os
     produtos da loja. Então marco aqui, uma vez, pela mesma regra dos outros:
     a foto vinculada à variante abre o bloco daquela cor e as seguintes são
     dela até a próxima. O mapa de "que arquivo abre que cor" vem do Liquid. */
  Controlador.prototype.prepararGaleria = function () {
    var dados = document.querySelector('[data-tp-lc-galeria]');
    this.galeria = document.querySelector('media-gallery');
    if (!dados || !this.galeria) return;

    try { this.galeriaCfg = JSON.parse(dados.textContent); } catch (e) { return; }

    var capas = this.galeriaCfg.capasPorCor || {};
    var peca = this.galeriaCfg.peca;

    // Nome do arquivo é o que dá para ler de volta do src; o id da mídia não
    // aparece na URL da CDN.
    function arquivoDe(li) {
      var img = li.querySelector('img');
      var src = (img && (img.getAttribute('src') || '')) || '';
      return src.split('?')[0].split('/').pop();
    }

    var listas = this.listasDaGaleria();
    for (var l = 0; l < listas.length; l++) {
      var cor = '';
      for (var i = 0; i < listas[l].length; i++) {
        var li = listas[l][i];
        if (li.hasAttribute('data-tp-peca')) continue;  // já veio marcado do Liquid
        var arq = arquivoDe(li);
        if (capas[arq]) cor = capas[arq];
        li.setAttribute('data-tp-peca', peca);
        li.setAttribute('data-tp-cor', cor);
      }
    }
  };

  /* Mostra na galeria a peça `iProd` da caixa `iCaixa`.

     O FILTRO É POR PEÇA, NÃO POR COR. Por cor, a galeria virava uma lista de
     seis fotos e a cliente perdia o resto da peça; e a troca de cor era um
     corte seco, sem para onde olhar. Agora a peça entra INTEIRA e a cor vira
     ALVO: a galeria caminha até a foto daquela cor.

     Duas transições, porque o slider é duas coisas diferentes:

     - no celular a lista rola de verdade, então dá para ir até a foto passando
       pelas outras. É esse movimento que diz "continua sendo a mesma peça";
     - no desktop o Dawn esconde todo slide que não é o ativo (display:none, ver
       section-main-product.css), então não existe caminho para percorrer. Lá a
       transição é um fade curto — é o que dá para fazer sem reescrever a
       galeria do tema.

     Trocar de PEÇA é fade nos dois: são fotos de outro produto, não há
     continuidade para animar. */
  Controlador.prototype.mostrarNaGaleria = function (iCaixa, iProd, rolar) {
    if (!this.galeria) return;
    var p = this.caixas[iCaixa].produtos[iProd];
    if (!p) return;

    var self = this;
    var peca = (p.url || '').split('?')[0].split('/').pop();
    var cor = (this.corDe(iCaixa, iProd) || '').trim();

    if (this.pecaNaGaleria !== peca) {
      this.pecaNaGaleria = peca;
      this.comFade(function () {
        self.filtrarPeca(peca);
        self.irAteACor(cor, false);
      });
    } else {
      this.irAteACor(cor, true);
    }

    if (rolar && window.matchMedia('(max-width: 749px)').matches) {
      this.galeria.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  /* Só as fotos desta peça ficam na galeria — todas as cores dela. As outras
     peças continuam no DOM, escondidas: é o que permite ir e voltar sem
     recarregar nada. */
  Controlador.prototype.filtrarPeca = function (peca) {
    var listas = this.listasDaGaleria();
    var achou = false;

    for (var l = 0; l < listas.length; l++) {
      for (var i = 0; i < listas[l].length; i++) {
        var li = listas[l][i];
        var minha = li.getAttribute('data-tp-peca') === peca;
        li.hidden = !minha;
        if (minha) achou = true;
      }
    }

    /* Peça sem foto marcada: desfaz o filtro em vez de deixar a galeria vazia.
       Acontece se alguém subir peça nova sem vincular foto a variante. */
    if (!achou) {
      for (var a = 0; a < listas.length; a++) {
        for (var b = 0; b < listas[a].length; b++) listas[a][b].hidden = false;
      }
      return;
    }

    var visor = this.galeria.querySelector('slider-component[id^="GalleryViewer"]');
    var minis = this.galeria.querySelector('slider-component[id^="GalleryThumbnails"]');
    if (visor && typeof visor.resetPages === 'function') visor.resetPages();
    if (minis && typeof minis.resetPages === 'function') minis.resetPages();
  };

  /* Leva a galeria até a primeira foto da cor. `suave` só vale onde a lista
     rola; onde o Dawn troca por display, vira fade. */
  Controlador.prototype.irAteACor = function (cor, suave) {
    var lista = this.galeria.querySelector('.product__media-list');
    if (!lista) return;

    var visiveis = [];
    var alvo = null;
    var filhos = lista.children;
    for (var i = 0; i < filhos.length; i++) {
      var li = filhos[i];
      if (li.hidden) continue;
      visiveis.push(li);
      var liCor = (li.getAttribute('data-tp-cor') || '').trim();
      if (!alvo && cor && liCor && semAcento(liCor) === semAcento(cor)) alvo = li;
    }
    if (!alvo) alvo = visiveis[0];
    if (!alvo) return;

    var self = this;
    var aplicar = function () {
      for (var k = 0; k < filhos.length; k++) filhos[k].classList.remove('is-active');
      alvo.classList.add('is-active');
      var mini = self.galeria.querySelector('.thumbnail-list [data-target="' + alvo.dataset.mediaId + '"]');
      if (mini && typeof self.galeria.setActiveThumbnail === 'function') {
        self.galeria.setActiveThumbnail(mini);
      }
    };

    var rola = lista.scrollWidth - lista.clientWidth > 8;
    if (rola) {
      aplicar();
      lista.scrollTo({ left: alvo.offsetLeft, behavior: suave && !semMovimento() ? 'smooth' : 'auto' });
    } else if (suave) {
      this.comFade(aplicar);
    } else {
      aplicar();
    }
  };

  /* O fade é da galeria, não daqui: o media-gallery.js passou a fazer a mesma
     transição para a loja inteira. Chamo o dele para as duas telas nunca
     divergirem em duração nem em quando o fade acontece. */
  Controlador.prototype.comFade = function (troca) {
    if (this.galeria && typeof this.galeria.comFade === 'function') {
      this.galeria.comFade(troca);
      return;
    }
    troca();
  };

  Controlador.prototype.listasDaGaleria = function () {
    return [
      this.galeria.querySelectorAll('.product__media-list > li'),
      this.galeria.querySelectorAll('.thumbnail-list > li')
    ];
  };

  /* VERSÃO DA PEÇA (com/sem bolso) DENTRO DA CAIXA.

     A PDP troca de versão trocando a página inteira. Aqui isso não serve: a
     cliente perderia a caixa escolhida e o tamanho já marcado da outra peça, que
     é justamente o estado que a caixa existe para montar. Então as duas versões
     vêm embarcadas na página e a troca é só dos dados daquela peça — a mesma
     decisão que o kit tomou, pelo mesmo motivo.

     Marcação igual à do tp-versao-switcher e à do kit de propósito: o visual sai
     do tp-versao-switcher.css, sem uma terceira cópia do mesmo CSS. */
  Controlador.prototype.versaoHTML = function (iCaixa, iProd) {
    var v = (this.caixas[iCaixa].versoes || [])[iProd];
    if (!v || !v.alt) return '';

    var ativo = '<button type="button" class="tp-versao__opt is-ativa" aria-pressed="true" disabled>' +
      esc(v.rotuloAtual) + '</button>';
    var outro = '<button type="button" class="tp-versao__opt" aria-pressed="false" ' +
      'data-tp-lc-versao="' + iCaixa + '-' + iProd + '">' + esc(v.rotuloAlt) + '</button>';

    return '<div class="tp-versao tp-versao--kit">' +
      '<p class="tp-versao__label">Versão</p>' +
      '<div class="tp-versao__opcoes" role="group" aria-label="Escolha a versão da peça">' +
      (v.atualPrimeiro ? ativo + outro : outro + ativo) +
      '</div></div>';
  };

  /* Troca a versão da peça `iProd` da caixa `iCaixa`. Só ela: a outra peça, a
     outra caixa e o resto da página não são tocados.

     As duas versões trocam de papel no mesmo objeto, então dá para ir e voltar
     quantas vezes quiser. `atualPrimeiro` inverte junto, para os dois botões
     ficarem na MESMA posição física depois da troca — botão que muda de lugar
     embaixo do dedo faz a pessoa desistir.

     O tamanho escolhido é devolvido quando a outra versão tem o mesmo; a cor
     também, comparada sem acento porque uma versão escreve "Café" e a outra
     "Cafe". O id da variante antiga não sobrevive: é de outro produto. */
  Controlador.prototype.trocarVersao = function (iCaixa, iProd) {
    var v = (this.caixas[iCaixa].versoes || [])[iProd];
    if (!v || !v.alt) return;

    var corAntes = this.corDe(iCaixa, iProd);
    var tamAntes = this.sel[iCaixa][iProd];

    var saindo = this.caixas[iCaixa].produtos[iProd];
    this.caixas[iCaixa].produtos[iProd] = v.alt;
    v.alt = saindo;
    var rot = v.rotuloAtual; v.rotuloAtual = v.rotuloAlt; v.rotuloAlt = rot;
    /* `atualPrimeiro` INVERTE JUNTO, e e isso que trava a posicao fisica.
       Os papeis atual/alt acabaram de trocar de lado no objeto: se o produto
       que estava em primeiro passa a ser o "alt", entao `atualPrimeiro` tem de
       virar o oposto para ele continuar sendo desenhado em primeiro. Sem esta
       linha, o botao em que a cliente acabou de tocar reaparece do outro lado.

       Reverte a decisao de 21/08/2026 (versao atual sempre em primeiro), pelo
       motivo escrito em tp-versao-switcher.liquid: o que faltava era feedback,
       nao promocao do botao a primeira posicao. */
    v.atualPrimeiro = !v.atualPrimeiro;

    var novo = this.caixas[iCaixa].produtos[iProd];

    var cores = (novo.colors || []).map(function (c) { return c.name; });
    var cor = equivalente(cores, corAntes);
    this.cor[iCaixa][iProd] = cor || this.corPadrao(novo);

    var tams = this.tamanhos(novo, this.cor[iCaixa][iProd]);
    this.sel[iCaixa][iProd] = tams.indexOf(tamAntes) !== -1 ? tamAntes : null;

    /* `redesenhar` + `atualizar`, e não `montar`: o `ligar` de dentro do montar
       registra um listener novo no `raiz` a cada chamada, e como o clique é
       delegado o listener antigo continua vivo depois do innerHTML. Duas trocas
       de versão e cada clique da página passaria a disparar duas vezes. */
    this.redesenhar();
    this.atualizar();
    this.mostrarNaGaleria(iCaixa, iProd, false);
  };

  Controlador.prototype.abrirGuia = function (iCaixa, iProd, aba) {
    var self = this;
    var p = this.caixas[iCaixa].produtos[iProd];
    var modal = document.querySelector('[data-tp-lc-sg]');
    var alvo = document.querySelector('[data-tp-lc-sg-content]');
    var titulo = document.querySelector('[data-tp-lc-sg-title]');
    var barra = document.querySelector('[data-tp-lc-sg-abas]');
    if (!modal || !alvo) return;

    var abas = this.abasDaPeca(p);
    if (!abas.length) return;
    var atual = aba || abas[0].id;

    if (titulo) titulo.textContent = p.title;

    /* As MESMAS abas dentro do pop-up. Os botões da caixa ficam atrás do
       overlay, então sem isto trocar de conteúdo exigiria fechar e reabrir —
       três cliques para comparar a tabela com as medidas da peça. */
    if (barra) {
      barra.innerHTML = abas.map(function (ab) {
        return '<button type="button" class="tp-lc-sg__aba' + (ab.id === atual ? ' is-ativa' : '') +
          '" data-aba="' + attr(ab.id) + '">' + esc(ab.rotulo) + '</button>';
      }).join('');
      barra.querySelectorAll('[data-aba]').forEach(function (b) {
        b.addEventListener('click', function () { self.abrirGuia(iCaixa, iProd, b.dataset.aba); });
      });
    }

    var escolhida = abas.filter(function (ab) { return ab.id === atual; })[0] || abas[0];
    alvo.innerHTML = escolhida.html;
    ligarScripts(alvo);
    /* Volta ao topo a cada troca: a aba nova começa onde o olho está, não na
       altura em que a anterior tinha sido rolada. */
    alvo.scrollTop = 0;
    modal.hidden = false;
  };

  /* AVISE-ME (19/10/2026): a primeira peça da caixa aberta cujo tamanho escolhido está esgotado */
  Controlador.prototype.esgotadoEscolhido = function () {
    var self = this, caixa = this.caixas[this.atual], achou = null;
    (caixa.produtos || []).forEach(function (p, iProd) {
      if (achou) return;
      var t = self.sel[self.atual][iProd];
      if (!t) return;
      var cor = self.corDe(self.atual, iProd), v = self.variantePorTamanho(p, t, cor);
      if (v && !v.available) achou = { v: v, item: (p.title || '') + ' (' + [cor, t].filter(Boolean).join(' / ') + ')' };
    });
    return achou;
  };

  Controlador.prototype.adicionar = function () {
    var self = this;
    var caixa = this.caixas[this.atual];
    var esg = this.esgotadoEscolhido();
    if (esg) {
      if (window.tpAviseMe) window.tpAviseMe.abrir({ variantId: esg.v.id, item: esg.item, botao: this.elCta, rotuloEl: this.elCtaLabel });
      return;
    }
    var itens = [];
    (caixa.produtos || []).forEach(function (p, iProd) {
      var v = self.varianteMostrada(self.atual, iProd);
      if (v) itens.push({ id: v.id, quantity: 1 });
    });
    if (!itens.length) return;

    var rotulo = this.elCtaLabel ? this.elCtaLabel.textContent : '';
    this.elCta.disabled = true;
    if (this.elCtaLabel) this.elCtaLabel.textContent = 'Adicionando...';

    var gaveta = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var corpo = { items: itens };
    if (gaveta && typeof gaveta.getSectionsToRender === 'function') {
      corpo.sections = gaveta.getSectionsToRender().map(function (s) { return s.id; });
      corpo.sections_url = window.location.pathname;
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || 'falha ao adicionar');
        if (gaveta && typeof gaveta.renderContents === 'function') {
          if (gaveta.classList.contains('is-empty')) gaveta.classList.remove('is-empty');
          gaveta.renderContents(res);
        }
        if (gaveta && typeof gaveta.open === 'function') gaveta.open();
      })
      .catch(function (err) {
        console.error('[tp-lancamento]', err);
        if (self.elCtaLabel) self.elCtaLabel.textContent = rotulo;
      })
      .finally(function () { self.atualizar(); });
  };

  /* A galeria abre na foto PRINCIPAL do produto, nao na foto da variante.

     Sem seletor de cor na pagina, o tema cai em
     `selected_or_first_available_variant`, que aqui e a Bosque/P — e mostra a
     foto vinculada aquela cor. Numa pagina de UMA cor isso e so uma foto
     escolhida pelo caminho errado: quem define a capa e a ordem das midias do
     produto, e era essa a intencao de quem subiu as fotos. */
  /* O MODAL PRECISA SER FILHO DO <body>.

     `position: fixed` deixa de se ancorar na janela quando QUALQUER ancestral
     tem `transform`, `filter` ou `contain` — o ancestral vira o bloco de
     referência. A coluna do produto tem transform (animação de entrada do
     tema), então o modal do guia de medidas se prendia nela e abria centenas de
     pixels abaixo da tela. Nenhum ajuste de CSS resolve isso de dentro; mudar
     de pai, sim. */
  function soltarModal() {
    var m = document.querySelector('[data-tp-lc-sg]');
    if (m && m.parentElement !== document.body) document.body.appendChild(m);
  }

  function iniciar() {
    soltarModal();
    document.querySelectorAll('[data-tp-lc]').forEach(function (raiz) {
      var el = raiz.querySelector('.tp-lc__data');
      if (!el) return;
      var cfg;
      try { cfg = JSON.parse(el.textContent); } catch (e) { console.error('[tp-lancamento] JSON inválido', e); return; }
      if (!cfg.caixas || !cfg.caixas.length) return;
      new Controlador(raiz, cfg);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
